const state = {
    data: [],
    layout: [],
    section: [],
    configVersionNumber: null,
    formsList: [],
};

const getters = {
    getData: state => { return state.data; },
    getConfig: state => { return { config: { section: state.section, layout: state.layout } }; },
    getConfigVersionNumber: state => { return state.configVersionNumber; },
};

const mutations = {
    SET_FORM(state, payload) {
        const { data: { data, layout, section }, configVersionNumber } = payload;
        state.data = data;
        state.layout = layout;
        state.section = section;
        state.configVersionNumber = configVersionNumber;
    },

    SET_FORMS_LIST(state, payload) {
        state.formsList = payload.data;
    },
};

const actions = {
    async getFormById({ commit }, payload) {
        const { formId } = payload;
        const form = state.formsList.find(f => f.id === formId);

        commit('SET_FORM', {
            data: form.config,
            configVersionNumber: form.configVersionNumber
        });
        return form;
    },

    async createFormFromPublic({ commit }, payload) {
        const { appointmentId, establishmentId } = payload;
        await this._vm.$api.forms.createFormFromPublic(establishmentId, appointmentId, payload);
    },

    async getFormListByEstablishment({ commit }, payload) {
        const { establishmentId } = payload;
        const response = await this._vm.$api.forms.getAvailableForms(establishmentId);

        commit('SET_FORMS_LIST', {
            data: response.data,
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
